/**
 * Normalize an axios/FastAPI error into a readable string.
 * FastAPI returns `detail` as a string for HTTPException, but as an
 * array of {loc, msg, type} objects for 422 validation errors —
 * rendering that array directly crashes React (white page).
 */
export function getApiErrorMessage(err, fallback = 'Something went wrong') {
  const detail = err?.response?.data?.detail;
  if (typeof detail === 'string' && detail.trim()) return detail;
  if (Array.isArray(detail)) {
    const parts = detail.map((d) => {
      if (typeof d === 'string') return d;
      const field = Array.isArray(d?.loc) ? d.loc[d.loc.length - 1] : '';
      const msg = d?.msg || JSON.stringify(d);
      return field ? `${field}: ${msg}` : msg;
    });
    if (parts.length) return parts.join('; ');
  }
  if (detail && typeof detail === 'object') return JSON.stringify(detail);
  return err?.message || fallback;
}
